<template>
  <mdb-container>
    <banner-small :group="group" title="My Billing" v-if="group"/>
    <div v-if="details">
      <mdb-card class="mb-4">
        <mdb-card-header>
          <div ref="card"></div>

        </mdb-card-header>
        <mdb-card-body class="text-left">
          <b>Current Balance Due: </b>{{details.balanceDisplay}}

          <div v-if="details.balance <= 0 && !details.hasStripeInfo">
            Please add a credit card before signing up for an event that requires payment. You will not be charged until
            you make a reservation.
          </div>

          <div v-if="showStripe && details.allowStripe ">
            <card class='stripe-card'
                  :class='{ complete }'
                  :stripe='details.stripePublicKey'
                  @change='complete = $event.complete'
            />
            <mdb-input v-model="ccName" label="Name on Credit Card"/>
            <mdb-btn icon="check-circle" @click="pay" :disabled="!complete || !ccName"><span v-if="details.balance <=0">Save Card</span><span v-else>Pay {{details.balanceDisplay}}</span></mdb-btn>
            <mdb-btn v-if="details.hasStripeInfo" icon="minus-circle" @click="showStripe=false">Cancel</mdb-btn>
            <div class="text-info small">
              Neither {{group.name}} nor {{settings.siteName}} will have access to your credit card info. However, your email
              address will be shared with our payment processor (Stripe) and {{group.name}} administration will have access
              to that.
            </div>
          </div>
          <div v-if="!showStripe && details.allowStripe && details.hasStripeInfo">
            <p>Current Payment Method: {{ details.ccType }} ending in {{ details.ccLast4 }}, Expires {{ details.ccExpire }}</p>
            <mdb-btn color="success" v-if="details.balance > 0" icon="check-circle" @click="chargeCard">Pay {{details.balanceDisplay}} Now</mdb-btn>
            <mdb-btn color="warning" icon="pencil" @click="showStripe=true">Change Card</mdb-btn>
            <mdb-btn icon="trash" @click="deleteModal = true" color="danger">Remove Card</mdb-btn>
          </div>
          <div class="small" v-if="!details.allowStripe && details.balance > 0 ">
            {{group.name}} is not set up to receive payments electronically. Please contact the group administrator
            or an event organizer to arrange to make payments.
          </div>
        </mdb-card-body>
      </mdb-card>
      <mdb-card class="mb-4">
        <mdb-card-header>
          <h5>Transaction History</h5>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <mdb-tbl responsive striped>
            <mdb-tbl-head class="primary-color text-white">
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Amount</th>
                <th>Source</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="t in details.transactions">
                <td class="text-left">{{t.date}}</td>
                <td class="text-left">{{t.description}}</td>
                <td class="text-right">{{t.amount}}</td>
                <td class="text-left">{{t.source}}</td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>

        </mdb-card-body>
      </mdb-card>

    </div>
    <yes-no-modal @yes="removeCard" @no="deleteModal=false" v-if="deleteModal"/>

  </mdb-container>
</template>

<script>
import editor from '@tinymce/tinymce-vue'
import memberAccess from './MemberAccess'
import memberBilling from './MemberBilling'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardGroup,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbListGroup,
  mdbListGroupItem,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbSelect,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbTooltip,
  mdbView,
} from 'mdbvue';
import BannerSmall from "./BannerSmall"
import Avatar from "../common/Avatar"
import {mapState} from "vuex";
import {Datetime} from 'vue-datetime'
import api from "../../services/groupsPlaceApi";
import {Card, createToken} from 'vue-stripe-elements-plus'
import YesNoModal from "../common/YesNoModal";

export default {
    name: 'Member-Billing',
    components: {
      BannerSmall,
      mdbContainer,
      mdbCardGroup,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbCardFooter,
      mdbCardTitle,
      mdbCardText,
      mdbCardImage,
      mdbTbl,
      mdbTblHead,
      mdbTblBody,
      mdbIcon,
      mdbInput,
      mdbView,
      mdbMask,
      mdbBtn,
      mdbRow,
      mdbListGroup,
      mdbListGroupItem,
      mdbCol,
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbModalFooter,
      mdbSelect,
      mdbTooltip,
      mdbBadge,
      Avatar,
      Datetime,
      editor,
      memberAccess,
      memberBilling,
      Card,
      YesNoModal
    },
    data() {
      return {
        //details: { balance: null, transactions:[], allowStripe: false, groupId: null }
        ccName: "",
        details: null,
        complete: false,
        showStripe: true,
        deleteModal: false,
        stripeOptions: {
          requestPayerName: true,
          requestPayerEmail: true
        }
      }
    },
    computed: mapState({
                         group: state => state.currentGroup,
                         userDetails: state => state.userDetails,
                         settings: state => state.settings
                       }),
    mounted() {
      this.$store.dispatch("setExecuting", true);
      this.loadDetails()
    },
    methods: {
      pay () {
        // createToken returns a Promise which resolves in a result object with
        // either a token or an error key.
        // See https://stripe.com/docs/api#tokens for the token object.
        // See https://stripe.com/docs/api#errors for the error object.
        // More general https://stripe.com/docs/stripe.js#stripe-create-token.
        createToken().then(data =>
          this.submitPayment(data.token)
        )
      },
      submitPayment(token) {
        this.$store.dispatch("setExecuting", true);
        let payload = {token:token.id, name: this.ccName}
        api.post("/group/stripeInfo/" + this.$route.params.id, payload).then(
          (results) => {
            this.loadDetails()
            this.$store.dispatch("updateGroupBalance")
          },
          (error) => {
            this.$notify.error({message: "Could not post payment. " + error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      chargeCard() {
        this.$store.dispatch("setExecuting", true);
        api.post("/group/stripeCharge/" + this.$route.params.id, {}).then(
          (results) => {
            this.loadDetails()
            this.$store.dispatch("updateGroupBalance")
          },
          (error) => {
            this.$notify.error({message: "Could not post payment. " + error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      removeCard() {
        this.deleteModal = false
        this.$store.dispatch("setExecuting", true);
        api.post("/group/removeCard/" + this.$route.params.id, {}).then(
          (results) => {
            this.loadDetails()
            this.showStripe = true
            this.$store.dispatch("updateGroupBalance")
          },
          (error) => {
            this.$notify.error({message: "Could not post payment. " + error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      loadDetails() {
        this.details = {}
        this.$store.dispatch("setExecuting", true);
        api.get("/group/billing/" + this.$route.params.id).then(
          (results) => {
            this.details = results.data;
            if (this.details.hasStripeInfo) this.showStripe = false
            if (!this.group || this.group.id != this.details.groupId) {
              api.groupBasics(this.details.groupId, "member");
            }
            document.title = "Billing";
          },
          (error) => {
            this.$notify.error({message: "Could not load billing. " + error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })

      }
    }
  }

</script>
<style scoped>
  .stripe-card {
    width: 300px;
    border: 1px solid grey;
  }

  .stripe-card.complete {
    border-color: green;
  }
</style>
